import {Component, OnInit} from '@angular/core';
import {DomainService} from 'common-domain';
import {Router} from '@angular/router';
import {AuthService, RequestMetadata, TopLevelDomain} from 'common-domain';
import {Location} from "@angular/common";

@Component({
    selector: 'app-all-domains-list-view',
    templateUrl: './all-domains-list-view.component.html',
    styleUrls: ['./all-domains-list-view.component.scss'],
    standalone: false
})
export class AllDomainsListViewComponent implements OnInit {
  private domain: TopLevelDomain;

  constructor(private domainService: DomainService, private router: Router, private auth: AuthService, private location: Location) {
  }

  ngOnInit() {
  }

  onBack() {
    this.location.back();
  }

  editDomain(domainID: string) {
    this.domainService.getDomainByID(domainID).subscribe(data => {
      this.domain = data;
    }, () => {
    }, () => {
      const requestMetadata: RequestMetadata = {
        domainName: this.domain.name.toLowerCase().trim() === '.' ? 'root' : this.domain.name.toLowerCase().trim(),
        requestType: 'UPDATE',
        submissionOriginType: 'Web',
        dateOfSubmission: ''
      };

      this.router.navigate([`/domain/create-request/` + domainID], {
        state: {
          requestMetadata: requestMetadata,
          domain: this.domain
        }
      });

    });
  }
}
